import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach the session token as a Bearer header as a fallback for browsers/webviews
// that block third-party (SameSite=None) cookies — fixes intermittent login failures on mobile.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (localStorage.getItem("agent_mode") === "1") config.headers["X-Agent-Mode"] = "1";
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    // Ne PAS effacer le jeton sur un 401 isolé : un endpoint qui renvoie 401
    // ne doit pas déconnecter l'agent. Seul /auth/me (AuthContext) décide.
    return Promise.reject(error);
  }
);

export default api;
export { API };
